import Vue from 'vue'
import Vuex from 'vuex'
import storage                              from 'good-storage';
import dynamicRouterConfig from '../../router/dynamic-router-config'
import routerUtils from '../../util/router-utils'
import LeftMenuConfig from '@/config/left-menu-config'

Vue.use(Vuex)

const state = {
    menus: [],
    dynamicRouter: [],
    dynamicLeftMenu: []
}

const mutations = {
    updateMenus(state, pMenus) {
        state.menus = pMenus;
    },
    updateDynamicRouter(state, routers) {
        state.dynamicRouter = routers;
        // 更新缓存中的路由
        routerUtils.saveObjArr('router', routers);
    },
    updateDynamicLeftMenu(state, leftMenu) {
        state.dynamicLeftMenu = leftMenu;
        storage.session.set('dynamicLeftMenu', leftMenu);
    }
}

const getters = {
    dynamicRouter: state => state.dynamicRouter,
}

const actions = {
    dynamicMenu({commit, dispatch}, menus) {
        // debugger;
        commit('updateMenus', menus);
        let dMenuUrlArray = [];
        menus.map(item => {
          dMenuUrlArray.push(item.menuUrl)
        });
        let routers = dynamicRouterConfig;
        
        // 判断是否关闭动态路由功能
        if ( process.env.IS_CLOSE_DYNAMIC_ROUTING ) {
            routers = routerUtils.sortRouter(routers, menus);
            commit('updateDynamicRouter', routers);
            dispatch('dynamicLeftMenu');
        }

        let flag = routerUtils.whileJudgeRouter(routers, dMenuUrlArray);
        // 被玩出花来的js，用lambda表达式写的递归。看不懂就算了，劝退
        let filterFalseRouter = n => n.filter(i => (i.children != undefined && i.children.length > 0) ? i.children = filterFalseRouter(i.children) : i.showFlag);
        routers = filterFalseRouter(routers);
        routers.push({
          path: '*',
          name: 'error',
          component: 'error',
          redirect: '/404',
          hidden: true
        });
        routers = routerUtils.sortRouter(routers, menus);
        commit('updateDynamicRouter', routers);
        dispatch('dynamicLeftMenu');
    },
    /**
     * 动态获取左侧菜单栏
     * @param {} param0 
     */
    dynamicLeftMenu({commit, state}) {
        let leftMenuConfig = LeftMenuConfig
        // 开发环境不做 路由限制
        if ( process.env.NODE_ENV != "development" ) {
            let dMenuUrlArray = [];
            state.menus.map(item => {
                dMenuUrlArray.push(item.menuUrl)
            });
            let flag = routerUtils.whileJudgeRouter(leftMenuConfig, dMenuUrlArray);
            // 被玩出花来的js，用lambda表达式写的递归。看不懂就算了，劝退
            // let filterFalseRouter = n => n.filter(i => (i.children != undefined && i.children.length > 0) ? i.children = filterFalseRouter(i.children) && i.children.length > 0 : i.showFlag);
            // let filterFalseRouter = n => n.filter(i => (i.children) ? (i.children && (i.children = filterFalseRouter(i.children))) : i.showFlag);
            // let filterFalseRouter = n => n.filter(i => {
            //     if (i.children) {
            //         i.children = filterFalseRouter(i.children);
            //         if (i.children && i.children.length > 0 && i.showFlag) {
            //           return i;
            //         }
            //     }
            //     ipf (i.showFlag) {
            //         return i;
            //     }
            // });
            leftMenuConfig = routerUtils.hideNotShow(leftMenuConfig);
        }
        leftMenuConfig = routerUtils.sortRouter(leftMenuConfig, state.menus);
        commit('updateDynamicLeftMenu', leftMenuConfig);
        // sessionStorage.setItem('dynamicLeftMenu', leftMenuConfig);
    },
    updateDynamicRouter({commit, state}, array) {
      commit('updateDynamicRouter', array);
    },
    clearStatus({commit, state}, array) {
        commit('updateDynamicRouter', []);
        commit('updateMenus', []);
        commit('updateDynamicLeftMenu', []);
    }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/menu.js